type IconProps = React.ComponentProps<'svg'>

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 8.25)">
        <path
          d="M12.2197 0.21967C12.5126 -0.0732233 12.9873 -0.0732233 13.2802 0.21967C13.5731 0.512568 13.5731 0.987342 13.2802 1.28022L7.28022 7.28022C6.98734 7.57309 6.51257 7.57305 6.21967 7.28022L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L6.74994 5.6894L12.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
